var checkOfferPage = () => {
	const previous_url = new URL(document.referrer);
	if (
		previous_url.pathname === '/pages/immune5' ||
		previous_url.pathname === '/pages/belly5' ||
		previous_url.pathname === '/pages/belly6' ||
		previous_url.pathname === '/pages/belly8' ||
		previous_url.pathname === '/pages/belly9' ||
		previous_url.pathname === '/pages/belly10' ||
		previous_url.pathname === '/pages/belly11' ||
		previous_url.pathname === '/pages/move6' ||
		previous_url.pathname === '/pages/move7' ||
		previous_url.pathname === '/pages/move8' ||
		previous_url.pathname === '/pages/move9' ||
		previous_url.pathname === '/pages/pee5' ||
		previous_url.pathname === '/pages/pee6' ||
		previous_url.pathname === '/pages/pee7' ||
		previous_url.pathname === '/pages/pee8' ||
		previous_url.pathname === '/pages/smile5' ||
		previous_url.pathname === '/pages/smile6'
	) {
		document.body.setAttribute('offer-page', true);
	}
}